import { image } from '@/api/media'
const state = {}
const mutations = {
    SET_USER: (state, userinfo) => {
        state.user = userinfo
    },
    SET_TEAM: (state, detail) => {
        state.team = detail
    },
    SET_USERDETAIL: (state, detail) => {
        state.user.detail = detail
    }
}
const actions={
    upload({commit,dispatch},data){
        return new Promise((resolve, reject) => {
            console.log(data,typeof data)
            if (typeof data =='object' && data != null){
                // 如果输入data 为文件
                dispatch('base64',data).then(res=>{
                    image({ file: res }).then(path => {
                        if (path.code == "0") {
                            resolve(path.o_ret.path)
                        }else{
                            reject(path.message)
                        }

                    })
                })
            }else if (typeof data =='string'){
                //  如果输入为
                image({ file: data }).then(res => {
                    if (res.code == "0") {
                        resolve(res.o_ret.path)
                    } else {
                        reject(res.message)
                    }
                })
            }else{
                reject('类型错误， 只能使用file类型或者Base64压缩图片')
            }

        })
    },
    base64({},file){
        return new Promise(function (resolve, reject) {
            let reader = new FileReader();
            let imgResult = "";
            reader.readAsDataURL(file.raw);
            reader.onload = function () {
                imgResult = reader.result;
            };
            reader.onerror = function (error) {
                reject(error);
            };
            reader.onloadend = function () {
                resolve(imgResult);
            };
        });
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/media.js